
import { SettingTabs } from '@/components/settings/SettingTabs';
import { RequiresClientOrg, useClientOrg } from '@/context/ClientScopeProvider';
import { ActingOrg } from '@/context/ActingOrgProvider';

function Users() {
  const { orgId, client } = useClientOrg();

  return (
    <div className="space-y-4" data-testid="client-users-page">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">People</h2>
          <p className="text-muted-foreground">
            Who at {client.company_name} can use BitSwan, and what they can
            reach.
          </p>
        </div>
      </div>

      <ActingOrg orgId={orgId}>
        <SettingTabs />
      </ActingOrg>
    </div>
  );
}

export default function ClientUsersPage() {
  return (
    <RequiresClientOrg>
      <Users />
    </RequiresClientOrg>
  );
}
